module.exports = __webpack_public_path__ + "static/media/apartment3.d25c5270.jpg";